module.exports = "<div class=\"offline-ribbon bg-primary\" v-if=\"!onLine\">\n    <s-localized-string value=\"offlineRibbon.offline\" />\n</div>\n"